<div *ngIf="!showLoading" class="container">
  <div id="affiliation-code">
    <img id="link-img" src="assets/images/utf_success.svg" alt="Success">
    <div class="affHeading">
        <p id="heading1">{{cfetLabels.cfet_affiliation_code.heading1}}</p>
          <p id="heading2">{{affiliateName}}</p>
      </div>
      <div class="affCodeDesc">
        <p id="desc1">{{cfetLabels.cfet_affiliation_code.desc1_utf}}</p>
        <p id="desc2">{{cfetLabels.cfet_affiliation_code.desc2_utf}}</p>
      </div>
      <hr>

      <div class="btn-container">
        <button type="button" id="btn-continue" (click)="continue($event)" (keyup)="continue($event)"
          class="utf-button-blue" tabindex="0"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.continue}}</button>
      </div>
  </div>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>
